export default {
  name: 'statistics',
  path: '/statistics'
}